<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar/>
      <main class="main">
        <breadcrumb class="mb-0" :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside/> -->
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import AppHeader from './layout/Header'
import Sidebar from './layout/Sidebar'
import AppAside from './layout/Aside'
import AppFooter from './layout/Footer'
import Breadcrumb from './layout/Breadcrumb'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      contentStyleObj: {
        height: '100px',
        overflow: 'auto'
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  },
  mounted () {
    if (document.documentElement.clientWidth < 600) {
      this.$notify({
        title: '提示',
        message: '点击 三 按钮切换功能',
        position: 'top-left'
      });
    }
    // this.contentStyleObj.height = document.documentElement.clientHeight + 'px'
    window.onresize = function () {
      // this.contentStyleObj.height = document.documentElement.clientHeight + 'px'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Full.vue